import { useState } from 'react'
import {BrowserRouter, Route, Routes } from 'react-router-dom';
import {SearchProvider} from 'src/context/SearchContext';
import DefaultLayout from 'src/layouts/Default';
import Home from 'src/pages/Home';
import Item from 'src/pages/Item';
import Error404 from 'src/pages/Error404';


// import reactLogo from './assets/react.svg'
// import viteLogo from '/vite.svg'

import "semantic-ui-css/components/icon.min.css"
import "semantic-ui-css/components/loader.min.css"
import 'src/css/main.scss'
import 'src/css/SearchBox.scss'
import 'src/css/Header.scss';
import 'src/css/Footer.scss';
import 'src/css/Creditos.scss';



const basename = import.meta.env.VITE_BASE_URL || '/';

function App() {
  const [count, setCount] = useState(0)

  return (
      <SearchProvider>
          <BrowserRouter basename={basename}>
              <Routes>
                <Route element={<DefaultLayout/>}>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/item/:id" element={<Item />} />
                    <Route path="*" element={<Error404/>} />
                </Route>
              </Routes>
          </BrowserRouter>
      </SearchProvider>
  )
}

export default App
